module.exports = __webpack_public_path__ + "static/media/edu11.463ed484.jpg";